import packageIcon from '../assets/images/icon-package.png';
import detailsIcon from '../assets/images/icon-details.png';
import resultsIcon from '../assets/images/icon-results.png';

import path1 from '../assets/images/path-1.png';
import path2 from '../assets/images/path-2.png';

export default function OurProcess() {
	return (
		<>
			<section className="container my-24 mx-auto px-24 text-center">
				<h2 className="my-5 text-3xl font-bold">Our Process</h2>
				<p className="font-semibold">Experience an easy, simple, and effortless ordering process with us. From the moment you visit our website, you're on your way to real, bot-free engagement. We have a straightforward process that ensures your social media growth is not only effective but also secure and reliable! We've helped over half a million clients boost their online presence, and we're ready to do the same for you.</p>
			</section>
			<section className="container mx-auto px-24 flex flex-row">
				<div className="flex flex-row md:flex-row max-md:flex-col items-center">
					<div className="flex-none md:inline-flex max-md:hidden">
						<img src={packageIcon} alt="Package icon" />
					</div>
					<div className="grow">
						<h2 className="my-5 text-2xl font-bold">Select Package</h2>
						<p>Choose from a wide range of competitively priced packages designed for all major social platforms. Whether you're a small business looking to boost your Facebook page or an influencer aiming to increase Instagram followers, we have a solution tailored to your unique needs.</p>
					</div>
					<div className="flex-none md:hidden max-md:inline-flex">
						<img src={packageIcon} alt="Package icon" />
					</div>
				</div>
			</section>
			<section className="container mx-auto px-24 flex flex-row">
				<img className="mx-auto" src={path1} alt="Package path Details" />
			</section>
			<section className="container mx-auto px-24 flex flex-row">
				<div className="flex flex-row md:flex-row max-md:flex-col items-center">
					<div className="grow">
						<h2 className="my-5 text-2xl font-bold">Enter Details</h2>
						<p>Getting started is as simple as providing your profile link or username – that's it! We respect your privacy and security, so there’s no need to share your passwords or grant us extensive permissions. Your ease and peace of mind are at the forefront of our service.</p>
					</div>
					<div className="flex-none">
						<img src={detailsIcon} alt="Details icon" />
					</div>
				</div>
			</section>
			<section className="container mx-auto px-24 flex flex-row">
				<img className="mx-auto" src={path2} alt="Details path Results" />
			</section>
			<section className="container mx-auto px-24 flex flex-row">
				<div className="flex flex-row md:flex-row max-md:flex-col items-center">
					<div className="flex-none md:inline-flex max-md:hidden">
						<img src={resultsIcon} alt="Results icon" />
					</div>
					<div className="grow">
						<h2 className="my-5 text-2xl font-bold">Enjoy The Results</h2>
						<p>Sit back and watch your social media profile transform. With our commitment to real, quality engagement, you'll see a noticeable increase in followers, likes, and comments. Enhance your online influence and credibility, and witness a dramatic boost in your reach and engagement, all while enjoying our round-the-clock customer support.</p>
					</div>
					<div className="flex-none md:hidden max-md:inline-flex">
						<img src={resultsIcon} alt="Results icon" />
					</div>
				</div>
			</section>
		</>
	)
}
